import ApplicantServices from "../../services/ApplicantServices";
import LoaderUtils from "../../utils/BaseUtils/LoaderUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import Utils from "../../utils/Utils";
import AuthServices from "@/services/AuthServices";
const authService = new AuthServices();
const applicantService = new ApplicantServices();

export const state = {
  applicantInfo: {},
  roles: {},
  skills: [],
  industries: [],
  editProfileModalOpen: false,
  editEducationModalOpen: false,
  employments: [],
  projects: [],
  educations: [],
  addEmploymentSuccess: false,
  editProjectSuccess: false,
  deleteProjectSuccess: false,
  editEmploymentSuccess: false,
  deleteEmploymentSuccess: false,
  editProfileSuccess: false,
  editPortfolioSuccess: false,
  applicantProfile: {},
  applicantLocationProfileObj: {},
  applicantEducation: [],
  addEducationSuccess: false,
  portfolioLinks: [],
  applicantInfoProgress: 30,
  allJobs: [],
  appliedJobs: [],
  currentApplied: 0,
  interviews: [],
  applicationSuccess: false,
  acceptInterviewSuccess: false,
  declineInterviewSuccess: false,
  rescheduleInterviewSuccess: false,
  userId: "",
  newInterviewDate: "",
  location: "",
  interviewDate: "",
  applicantid: "",
  interviewId: "",
  jobId: "",
  singleInterview: {},
  offers: [],
  allApplicants: {},
  singleJob: {}
};

export const namespaced = true;

export const getters = {
  getUserInfo: state => {
    return state.userInfo;
  },
  getApplicantId: state => {
    return state.applicantProfile.id;
  },
  getApplicantAuthToken: state => {
    let token = state.applicantInfo.token;
    if (token) {
      return token;
    } else {
      return Utils.getFromLocalStorage("token");
    }
  },
  getMobileNumber: state => {
    return state.applicantProfile.mobilenumber;
  },
  getRoles: state => {
    return state.roles;
  },
  getSkills: state => {
    return state.skills;
  },
  getIndustries: state => {
    return state.industries;
  },
  getPortfolioList: state => {
    return state.applicantInfo.portfolio;
  },
  getProjectList: state => {
    return state.applicantInfo.projects;
  },
  getEducationList: state => {
    return state.educations;
  },
  getEmploymentList: state => {
    return state.applicantInfo.employments;
  },
  getApplicantProfileDetail: state => {
    return state.applicantProfile;
  },
  getEditProfileModalOpen: state => {
    return state.editProfileModalOpen;
  },
  getEditEducationModalOpen: state => {
    return state.editEducationModalOpen;
  },
  getEmploymentHistory: state => {
    return state.employments;
  },
  getProjectHistory: state => {
    return state.projects;
  },
  getAddEmploymentSuccess: state => {
    return state.addEmploymentSuccess;
  },
  getAddEducationSuccess: state => {
    return state.addEducationSuccess;
  },
  getEditProjectSuccess: state => {
    return state.editProjectSuccess;
  },
  getDeleteProjectSuccess: state => {
    return state.deleteProjectSuccess;
  },
  getEditEmploymentSuccess: state => {
    return state.editEmploymentSuccess;
  },
  getDeleteEmploymentSuccess: state => {
    return state.deleteEmploymentSuccess;
  },
  getEditProfileSuccess: state => {
    return state.editProfileSuccess;
  },
  getEditPortfolioSuccess: state => {
    return state.editPortfolioSuccess;
  },
  getApplicantLocationProfileObj: state => {
    return state.applicantLocationProfileObj;
  },
  getPortfolioLinks: state => {
    return state.portfolioLinks;
  },
  getAllJobs: state => {
    return state.allJobs;
  },
  getAppliedJobs: state => {
    return state.appliedJobs;
  },
  getCurrentApplied: state => {
    return state.currentApplied;
  },
  getApplicantInterviews: state => {
    return state.interviews;
  },
  getAcceptInterviewSuccess: state => {
    return state.acceptInterviewSuccess;
  },
  getDeclineInterviewSuccess: state => {
    return state.declineInterviewSuccess;
  },
  getRescheduleInterviewSuccess: state => {
    return state.rescheduleInterviewSuccess;
  },
  getUserId: state => {
    return state.userId;
  },
  getNewInterviewDate: state => {
    return state.newInterviewDate;
  },
  getInterviewLocation: state => {
    return state.location;
  },
  getInterviewDate: state => {
    return state.interviewDate;
  },
  getApplicantInterviewId: state => {
    return state.applicantid;
  },
  getInterviewId: state => {
    return state.interviewId;
  },
  getJobId: state => {
    return state.jobId;
  },
  getSingleInterview: state => {
    return state.singleInterview;
  },
  getOffers: state => {
    return state.offers;
  },
  getAllApplicants: state => {
    return state.allApplicants;
  },
  getSingleJob: state => {
    return state.singleJob;
  },
  getApplicationSuccess: state => {
    return state.applicationSuccess;
  }
};

export const mutations = {
  SET_APPLICANT_INFO(state, payload) {
    state.applicantInfo = payload;
    state.applicantProfile = payload.details;
    state.educations = payload.educations;
    state.projects = payload.projects;
    state.employments = payload.employments;
    state.offers = payload.offers;
  },
  SET_APPLICANT_PROFILE_DETAIL(state, payload) {
    state.applicantProfile = payload;
  },
  SET_USER_MOBILE_NUMBER(state, payload) {
    state.userInfo.mobilenumber = payload;
  },
  SET_ROLES(state, payload) {
    state.roles = payload;
  },
  SET_SKILLS(state, payload) {
    state.skills = payload;
  },
  SET_INDUSTRIES(state, payload) {
    state.industries = payload;
  },
  SET_EDIT_PROFILE_MODAL(state, payload) {
    state.editProfileModalOpen = payload;
  },
  SET_EDIT_EDUCATION_MODAL(state, payload) {
    state.editEducationModalOpen = payload;
  },
  SET_EMPLOYMENT_HISTORY(state, payload) {
    state.employments = payload;
  },
  SET_PROJECT_HISTORY(state, payload) {
    state.projects = payload;
  },
  SET_ADD_EMPLOYMENT_SUCCESS(state, payload) {
    state.addEmploymentSuccess = payload;
  },
  SET_ADD_PROJECT_SUCCESS(state, payload) {
    state.addProjectSuccess = payload;
  },
  SET_ADD_EDUCATION_SUCCESS(state, payload) {
    state.addEducationSuccess = payload;
  },
  SET_EDIT_PROJECT_SUCCESS(state, payload) {
    state.editProjectSuccess = payload;
  },
  SET_DELETE_PROJECT_SUCCESS(state, payload) {
    state.deleteProjectSuccess = payload;
  },
  SET_EDIT_EMPLOYMENT_SUCCESS(state, payload) {
    state.editEmploymentSuccess = payload;
  },
  SET_DELETE_EMPLOYMENT_SUCCESS(state, payload) {
    state.deleteEmploymentSuccess = payload;
  },
  SET_EDUCATION_HISTORY(state, payload) {
    state.educations = payload;
  },
  SET_EDIT_PROFILE_SUCCESS(state, payload) {
    state.editProfileSuccess = payload;
  },
  SET_EDIT_PORTFOLIO_SUCCESS(state, payload) {
    state.editPortfolioSuccess = payload;
  },
  SET_APPLICANT_LOCATION_PROFILE(state, payload) {
    state.applicantLocationProfileObj = payload;
  },
  SET_PORTFOLIO(state, payload) {
    state.applicantProfile = payload;
  },
  SET_PORTFOLIO_LINKS(state, payload) {
    state.portfolioLinks = payload;
  },
  SET_APPLICANT_PROGRESS(state, payload) {
    state.applicantInfoProgress = payload;
  },
  SET_ALL_JOBS(state, payload) {
    state.allJobs = payload;
  },
  SET_APPLIED_JOBS(state, payload) {
    state.appliedJobs = payload;
  },
  SET_CURRENT_APPLIED(state, payload) {
    state.currentApplied = payload;
  },
  SET_APPLICANT_INTERVIEWS(state, payload) {
    state.interviews = payload;
  },
  SET_ACCEPT_INTERVIEW_SUCCESS(state, payload) {
    state.acceptInterviewSuccess = payload;
  },
  SET_DECLINE_INTERVIEW_SUCCESS(state, payload) {
    state.declineInterviewSuccess = payload;
  },
  SET_RESCHEDULE_INTERVIEW_SUCCESS(state, payload) {
    state.rescheduleInterviewSuccess = payload;
  },
  SET_USER_ID(state, payload) {
    state.userId = payload;
  },
  SET_NEW_INTERVIEW_DATE(state, payload) {
    state.newInterviewDate = payload;
  },
  SET_INTERVIEW_LOCATION(state, payload) {
    state.interviewLocation = payload;
  },
  SET_INTERVIEW_ID(state, payload) {
    state.interviewId = payload;
  },
  SET_APPLICANT_INTERVIEW_ID(state, payload) {
    state.applicantid = payload;
  },
  SET_INTERVIEW_DATE(state, payload) {
    state.interviewDate = payload;
  },
  SET_JOB_ID(state, payload) {
    state.jobId = payload;
  },
  SET_SINGLE_INTERVIEW(state, payload) {
    state.singleInterview = payload;
  },
  SET_APPLICANT_OFFERS(state, payload) {
    state.offers = payload;
  },
  SET_ALL_APPLICANTS(state, payload) {
    state.allApplicants = payload;
  },
  SET_SINGLE_JOB(state, payload) {
    state.singleJob = payload;
  },
  SET_APPLICATION_SUCCESS(state, payload) {
    state.applicationSuccess = payload;
  }
};

export const actions = {
  editUserProfile({}, userType = "applicant") {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    let object = StoreUtils.rootGetters(
      "applicant/getApplicantLocationProfileObj"
    );

    let payload = {
      ...formBody,
      state: object.state,
      country: object.country,
      applicantid:
        userType === "applicant"
          ? StoreUtils.rootGetters(
              StoreUtils.getters.applicant.GET_APPLICANT_ID
            )
          : StoreUtils.rootGetters(
              StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
            ).userid
    };

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EDIT_PROFILE_DETAILS,
        false
      );
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EDIT_PROFILE_SUCCESS,
        true
      );

      // StoreUtils.dispatch(
      // userType === "applicant"
      // ? StoreUtils.actions.applicant.FETCH_APPLICANT_DETAILS
      StoreUtils.dispatch(
        StoreUtils.actions.auth.APPLICANT_REFRESH_NON_BLOCKING
        // )
      );
    };

    authService.editUserProfile(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchApplicantDetails() {
    let payload = {
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_APPLICANT_INFO,
        responseData.details
      );
    };

    authService.fetchApplicantDetails(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchRolesAndSkills() {
    const successAction = response => {
      const roles = {};
      const skills = [];

      for (const roleObject of response.data) {
        const { role, skills: roleSkills } = roleObject;

        roles[role] = roleSkills;
        skills.push(...roleSkills);
      }

      StoreUtils.commit(StoreUtils.mutations.applicant.SET_ROLES, roles);
      StoreUtils.commit(StoreUtils.mutations.applicant.SET_SKILLS, skills);
    };

    applicantService.fetchRolesAndSkills(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchIndustries() {
    const successAction = response => {
      const industries = [];

      for (const industry of response.data) {
        industries.push(industry.industryname);
      }

      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_INDUSTRIES,
        industries
      );
    };

    applicantService.fetchIndustries(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  addEducation({}, addEducationSuccessFunc) {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      university: formBody.university,
      courseofstudy: formBody.courseofstudy,
      degree: formBody.degree,
      link: "https://github.com/juliophp",
      startdate: formBody.startdate,
      enddate: formBody.enddate,
      cgpa: "4.38",
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      addEducationSuccessFunc();
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_EDUCATION_HISTORY);
    };

    applicantService.addEducation(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  editEducation({}, editSuccessFunc) {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      ...formBody,
      cgpa: "4.38",
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_EDUCATION_HISTORY);
      editSuccessFunc();
    };

    applicantService.editEducation(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchEducationHistory() {
    let userid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EDUCATION_HISTORY,
        response.data
      );
    };

    applicantService.fetchEducationHistory(
      { userid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  addEmployment() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    let applicantid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(
        StoreUtils.actions.applicant.FETCH_EMPLOYMENT_HISTORY
      );
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_ADD_EMPLOYMENT_SUCCESS,
        true
      );
    };

    applicantService.addEmployment(
      { ...formBody, applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  editEmployment() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    let applicantid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(
        StoreUtils.actions.applicant.FETCH_EMPLOYMENT_HISTORY
      );
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EDIT_EMPLOYMENT_SUCCESS,
        true
      );
    };

    applicantService.editEmployment(
      { ...formBody, applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  deleteEmployment() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(
        StoreUtils.actions.applicant.FETCH_EMPLOYMENT_HISTORY
      );
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_DELETE_EMPLOYMENT_SUCCESS,
        true
      );
    };

    applicantService.deleteEmployment(
      formBody,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchEmploymentHistory() {
    let userid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EMPLOYMENT_HISTORY,
        response.data
      );
    };

    applicantService.fetchEmploymentHistory(
      { userid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  addProject({}, addProjectSuccessFunc) {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let applicantid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      addProjectSuccessFunc();
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_PROJECT_HISTORY);
    };

    applicantService.addProject(
      { ...formBody, applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  editProject() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let applicantid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_PROJECT_HISTORY);
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EDIT_PROJECT_SUCCESS,
        true
      );
    };

    applicantService.editProject(
      { ...formBody, applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  deleteProject() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_PROJECT_HISTORY);
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_DELETE_PROJECT_SUCCESS,
        true
      );
    };

    applicantService.deleteProject(
      formBody,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchProjectHistory() {
    let userid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_PROJECT_HISTORY,
        response.data
      );
    };

    applicantService.fetchProjectHistory(
      { userid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  editPortfolio() {
    const formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    const applicantid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    const successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(
        StoreUtils.actions.auth.APPLICANT_REFRESH_NON_BLOCKING
      );
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_EDIT_PORTFOLIO_SUCCESS,
        true
      );
    };

    applicantService.editPortfolio(
      { ...formBody, applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchPortfolio() {
    const successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_PORTFOLIO,
        response.details
      );
    };
    const applicantid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    applicantService.fetchPortfolio(
      { applicantid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchPortfolioLinks() {
    const successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_PORTFOLIO_LINKS,
        response.data
      );
    };

    applicantService.fetchPortfolioLinks(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchAllJobs() {
    const successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_ALL_JOBS,
        response.data
      );
    };

    applicantService.fetchAllJobs(
      {},
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchApplicantInterviews() {
    let payload = {
      userid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_APPLICANT_INTERVIEWS,
        response.data
      );
    };

    applicantService.fetchApplicantInterviews(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchAppliedJobs() {
    const successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_APPLIED_JOBS,
        response.data
      );
    };

    applicantService.fetchAppliedJobs(
      {
        applicantid: StoreUtils.rootGetters(
          StoreUtils.getters.applicant.GET_APPLICANT_ID
        )
      },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  applyJob(_, jobid) {
    const successAction = response => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_APPLICATION_SUCCESS,
        true
      );
    };

    applicantService.applyJob(
      {
        jobid,
        applicantid: StoreUtils.rootGetters(
          StoreUtils.getters.applicant.GET_APPLICANT_ID
        )
      },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  acceptInterview({}, payload) {
    let successAction = () => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_ACCEPT_INTERVIEW_SUCCESS,
        true
      );
      StoreUtils.dispatch(
        StoreUtils.actions.applicant.FETCH_APPLICANT_INTERVIEWS
      );
    };

    applicantService.acceptInterview(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  declineInterview({}, payload) {
    let successAction = () => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_DECLINE_INTERVIEW_SUCCESS,
        true
      );
      StoreUtils.dispatch(
        StoreUtils.actions.applicant.FETCH_APPLICANT_INTERVIEWS
      );
    };

    applicantService.declineInterview(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  rescheduleInterview({}, payload) {
    let successAction = () => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_RESCHEDULE_INTERVIEW_SUCCESS,
        true
      );

      if (payload.isRecruiter) {
        StoreUtils.dispatch(
          StoreUtils.actions.recruiter.FETCH_JOB_INTERVIEWS,
          payload.jobid
        );
      } else {
        StoreUtils.dispatch(
          StoreUtils.actions.applicant.FETCH_APPLICANT_INTERVIEWS
        );
      }
    };

    applicantService.rescheduleInterview(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchApplicantOffers() {
    let userid = StoreUtils.rootGetters(
      StoreUtils.getters.applicant.GET_APPLICANT_ID
    );

    let payload = {
      userid: userid
    };

    let successAction = response => {
      StoreUtils.commit("applicant/SET_APPLICANT_OFFERS", response.data);
    };

    applicantService.fetchApplicantOffers(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  fetchAllApplicants() {
    let successAction = responseData => {
      StoreUtils.commit(
        StoreUtils.mutations.applicant.SET_ALL_APPLICANTS,
        responseData.data.password
      );
    };

    authService.fetchAllApplicants(
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
